import { computed, MaybeRefOrGetter, toValue } from 'vue'

export const useOrder = (
  isOcrMaybeRefOrGetter: MaybeRefOrGetter<boolean>,
  isVisaMaybeRefOrGetter: MaybeRefOrGetter<boolean>
): { getOrder: (name: string) => number } => {
  const isOcrAvailable = toValue(isOcrMaybeRefOrGetter)
  const isVisa = toValue(isVisaMaybeRefOrGetter)
  const defaultOrder: Record<string, number> = {
    relationship: 3,
    fullName: 2,
    firstName: 2,
    lastName: 3,
    birthDate: 4,
    gender: 5,
    nationality: 6,
    country: 7,
    passport: 8,
    passportExpiryDate: 9,
    maritalStatus: 10,
  }

  const visaOrder: Record<string, number> = {
    ...defaultOrder,
    passport: 7,
    passportExpiryDate: 8,
    country: 9,
  }

  const ocrOrder: Record<string, number> = {
    ...defaultOrder,
    passport: 6,
    passportExpiryDate: 7,
    country: 8,
  }

  const currentOrder = computed(() => {
    if (isVisa) return visaOrder
    return isOcrAvailable ? ocrOrder : defaultOrder
  })

  return {
    getOrder: (name: string): number =>
      currentOrder.value[name as keyof typeof currentOrder.value] ?? 0,
  }
}
